import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ESignRoutingModule } from './e-sign-routing.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { SimplebarAngularModule } from 'simplebar-angular';

import { ESignDashboardComponent } from './e-sign-dashboard/e-sign-dashboard.component';
import { UiModule } from 'src/app/shared/ui/ui.module';
import { CustomersComponent } from './customers/customers.component';
import { DocumentsComponent } from './documents/documents.component';
import { OrdersComponent } from './orders/orders.component';
import { TemplatesComponent } from './templates/templates.component';
import { SharedModule as PrimeNgSharedModule } from 'primeng/api';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgPipesModule } from 'ngx-pipes';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgStepperModule } from 'angular-ng-stepper';
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { AddTemplateComponent } from './templates/add-template/add-template.component';

@NgModule({
  declarations: [
    ESignDashboardComponent,
    CustomersComponent,
    DocumentsComponent,
    OrdersComponent,
    TemplatesComponent,
    AddTemplateComponent,

  ],
  imports: [
    CommonModule,
    ESignRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetModule,
    SimplebarAngularModule,
    UiModule,
    SharedModule,
    PrimeNgSharedModule,

    NgPipesModule,
    CdkStepperModule,
    NgStepperModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    CKEditorModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
  ],
  exports: [ESignDashboardComponent]
})
export class ESignModule { }
